"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function reference(factory, basePath) {
    if (basePath === void 0) { basePath = ""; }
    // FIXME: IType return type is inconsistent with what is actually returned, however, results in the best type-inference results for objects...
    return {
        targetType: factory,
        basePath: basePath,
        isReference: true
    };
}
exports.reference = reference;
function isReferenceFactory(thing) {
    return thing.isReference === true;
}
exports.isReferenceFactory = isReferenceFactory;
//# sourceMappingURL=reference.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/utility-types/reference.js
// module id = 107
// module chunks = 0